import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { LocalisationHelpers } from '../../bootstrap/localisation';

const LocalisationContext = createContext<LocalisationHelpers | null>(null);

export const LocalisationProvider = ({
  children,
  value,
}: {
  value: LocalisationHelpers;
  children: ReactNode;
}) => (
  <LocalisationContext.Provider value={value}>
    {children}
  </LocalisationContext.Provider>
);

export const useLocalisation = (): LocalisationHelpers => {
  const ctx = useContext(LocalisationContext);
  if (!ctx) {
    throw new Error(
      'useLocalisation must be used within a LocalisationProvider',
    );
  }
  return ctx;
};
